import React, { useState, useEffect, useRef } from 'react';
import ProdeoLogo from './Prodeo Logo.png';

export interface Notification {
  id: string;
  message: string;
}

interface HeaderProps {
  notifications: Notification[];
  unreadCount: number;
  onOpen: () => void;
  onNotificationClick: (n: Notification) => void;
}

const BellIcon: React.FC<{ className?: string }> = ({ className = 'w-6 h-6' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className={className}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14.857 17.657a1.657 1.657 0 01-3.314 0m1.657-15a5.987 5.987 0 00-5.996 5.995c0 3.352-.95 5.013-1.584 5.998h15.16c-.633-.985-1.584-2.646-1.584-5.998a5.987 5.987 0 00-5.996-5.995z"
    />
  </svg>
);

const Header: React.FC<HeaderProps> = ({
  notifications,
  unreadCount,
  onOpen,
  onNotificationClick,
}) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;

    const handleClick = (e: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClick);
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, [open]);

  const toggle = () => {
    const next = !open;
    setOpen(next);
    if (next) onOpen();
  };

  return (
    <header className="fixed top-0 left-0 right-0 h-10 bg-blue-600 flex items-center px-4 shadow z-40">
      <img src={ProdeoLogo} alt="Prodeo Logo" className="h-8" />
      <div className="ml-auto relative" ref={wrapperRef}>
        <button onClick={toggle} className="relative text-white">
          <BellIcon />
          {unreadCount > 0 && (
            <span className="absolute -top-1 -right-1 bg-red-600 rounded-full text-xs w-5 h-5 flex items-center justify-center">
              {unreadCount}
            </span>
          )}
        </button>
        {open && (
          <div className="absolute right-0 mt-2 w-64 bg-white rounded shadow z-50">
            {notifications.length === 0 ? (
              <div className="p-2 text-sm text-gray-500">No notifications</div>
            ) : (
              notifications.slice(0, 5).map((n) => (
                <button
                  key={n.id}
                  onClick={() => {
                    onNotificationClick(n);
                    setOpen(false);
                  }}
                  className="block w-full text-left px-4 py-2 hover:bg-gray-100 text-sm"
                >
                  {n.message}
                </button>
              ))
            )}
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
